import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'helpycurrency'
})
export class HelpycurrencyPathPipe implements PipeTransform {

  transform(value: number, args?: number): any {
    return `${value} €`
  }

}

